import { render, staticRenderFns } from "./SubjectManagement.vue?vue&type=template&id=30005c20&scoped=true"
import script from "./SubjectManagement.vue?vue&type=script&lang=js"
export * from "./SubjectManagement.vue?vue&type=script&lang=js"
import style0 from "./SubjectManagement.vue?vue&type=style&index=0&id=30005c20&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30005c20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30005c20')) {
      api.createRecord('30005c20', component.options)
    } else {
      api.reload('30005c20', component.options)
    }
    module.hot.accept("./SubjectManagement.vue?vue&type=template&id=30005c20&scoped=true", function () {
      api.rerender('30005c20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/SubjectManagement.vue"
export default component.exports